import { useTranslation } from '../../../hooks/useTranslation';
import Modal from '../Modal/Modal';

interface LiveSyncStoppedModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const LiveSyncStoppedModal: React.FC<LiveSyncStoppedModalProps> = ({
  open,
  setOpen,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      modalShouldBeOpen={open}
      showButton={false}
      mainPromptText={t('Live Sync Stopped')}
      description={t(
        'Live sync has stopped after 10 minutes. Toggle it again to continue syncing data.'
      )}
      denyText={t('Close')}
      setChangeStatusModalOpen={setOpen}
    />
  );
};

export default LiveSyncStoppedModal;
